/* eslint-disable no-unused-vars */
import { useCallback, useId, useMemo } from 'react';
import * as S from './SelectedContent.styled';
import { IconButton, ParagraphWithTooltip } from 'components';
import { DeleteIcon } from 'assets/icons';
import { LocationSelectedItemName } from './LocationSelectedItemName';
import { goToLocationParent } from 'utils';

const getItemName = {
  continent: 'continent_name',
  country: 'country_name',
  region: 'region_name',
  city: 'city',
};

export const SelectedItem = ({
  uniqueIdToItemMap,
  id,
  headerWidth,
  uniqueIdToItemMapFromServer,
  searchIdToItemMap,
  selectedItemsAfterSearch$,
  includeSet,
  setIncludeSet,
  excludeSet,
  setExcludeSet,
  env,
  changesFlag,
}) => {
  const itemData =
    uniqueIdToItemMap.get(id) ??
    uniqueIdToItemMapFromServer.get(id) ??
    searchIdToItemMap.get(id) ??
    selectedItemsAfterSearch$.value.get(id);

  const width = useMemo(() => headerWidth - 16 - 16 - 8 - 32 - 5, [headerWidth]);

  const handleDeleteItem = useCallback(
    (itemData) => {
      changesFlag.current = true;
      const getId = itemData.uniq_id ?? itemData.id;
      if (excludeSet.has(getId)) {
        setExcludeSet((newExcludeSet) => newExcludeSet.delete(getId));
        return;
      }
      if (includeSet.has(getId)) {
        if (itemData.type === 'region') {
          setExcludeSet((newExcludeSet) =>
            [...excludeSet].forEach((uniq_id) => {
              const goToRegion = goToLocationParent(uniq_id, 'region');
              if (goToRegion === getId) return newExcludeSet.delete(uniq_id);
            }),
          );
        }
        if (itemData.type === 'country') {
          setExcludeSet((newExcludeSet) =>
            [...excludeSet].forEach((uniq_id) => {
              const goToCountry = goToLocationParent(uniq_id, 'country');
              if (goToCountry === getId) return newExcludeSet.delete(uniq_id);
            }),
          );
        }
        if (itemData.type === 'continent') {
          setExcludeSet((newExcludeSet) =>
            [...excludeSet].forEach((uniq_id) => {
              const goToContinent = goToLocationParent(uniq_id, 'continent');
              if (goToContinent === getId) return newExcludeSet.delete(uniq_id);
            }),
          );
        }
        setIncludeSet((newIncludeSet) => newIncludeSet.delete(getId));
        return;
      }
    },
    [excludeSet, includeSet],
  );

  return (
    <S.ItemContainer>
      <div style={{ width: `${width}px` }}>
        <ParagraphWithTooltip text={<LocationSelectedItemName itemData={itemData} env={env} />} />
      </div>

      <IconButton.SmallSize
        style={{ marginLeft: 'auto', minWidth: '32px' }}
        isDefaultMuted
        icon={DeleteIcon}
        type={IconButton.btnTypes.tertiary}
        onClick={() => handleDeleteItem(itemData)}
      />
    </S.ItemContainer>
  );
};
